import React from 'react';
import '../css/SellerPlan.css';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';




const SellerPlan = () => {
    const plans = [
        {
            id: 1,
            name: "Basic Plan",
            price: "₹499/month",
            features: [
                "List up to 5 properties",
                "Basic customer support",
                "Standard visibility",
            ],
        },
        {
            id: 2,
            name: "Standard Plan",
            price: "₹999/month",
            features: [
                "List up to 15 properties",
                "Priority customer support",
                "Enhanced visibility",
            ],
        },
        {
            id: 3,
            name: "Premium Plan",
            price: "₹1499/month",
            features: [
                "Unlimited property listings",
                "24/7 premium support",
                "Top-tier visibility",
            ],
        },
    ];

    return (
        <>
        <NavbarComponent/>
        <div className="seller-plan-page">
            <h1>Choose Your Seller Plan</h1>
            <div className="plans-container">
                {plans.map((plan) => (
                    <div className="plan-card" key={plan.id}>
                        <h2>{plan.name}</h2>
                        <p className="plan-price">{plan.price}</p>
                        <ul>
                            {plan.features.map((feature, index) => (
                                <li key={index}>{feature}</li>
                            ))}
                        </ul>
                        <button className="select-plan-button">Select Plan</button>
                    </div>
                ))}
            </div>
        </div>
        <FooterComponent/>
        </>

    );
};

export default SellerPlan;
